// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import orderConfirmation from './OrderConfirmation';

import { IRoute } from '../';

const orderRoutes: IRoute[] = [
    {
        crumbText: 'order_confirmation',
        component: orderConfirmation,
        exact: true,
        path: '/device/orderConfirmation',
    },
];

export default orderRoutes;